import { useMutation } from '@tanstack/react-query'
import { createContent } from '../index'

const useCreateContent = () =>
  useMutation({
    mutationFn: createContent,
  })

export default useCreateContent
